module.exports = __webpack_public_path__ + "img/ml-logo.d773fcb5.png";